import AdminDeliveryZonesPage from '../../../components/admin/settings/AdminDeliveryZonesPage'

export default function SettingsDeliveryZones() {
  return <AdminDeliveryZonesPage />
}
